(function () {
  if (!window.ab_test) return;

  if (window.ab_test.design_mode) {
    console.debug('[AB] Design mode: skipping assignment/persist.');
    return;
  }

  if (window.ab_test.source === 'editor') {
    console.debug('[AB] Editor override active, skip persist.');
    return;
  }

  var group = window.ab_test.group;
  var source = window.ab_test.source || 'default';
  var renderedGroup = window.ab_test.rendered_group || 'A';
  var isProduct = Boolean(window.ab_test.is_product);
  var isAbTestProduct = Boolean(window.ab_test.is_ab_test_product);
  var shouldPersist = source === 'client' || source === 'storage';

  if (source === 'cart' && group) {
    console.debug('[AB] Existing group from cart:', group);
    return;
  }

  if (!group) {
    console.warn('[AB] No finalized group available; skipping persist.');
    return;
  }

  if (!shouldPersist) {
    console.debug('[AB] Existing group from', source + ':', group);
    return;
  }

  console.debug('[AB] Persisting finalized group from', source + ':', group);

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: { ab_group: group }
    })
  })
    .then(function (res) {
      if (!res.ok) throw new Error('Bad status ' + res.status);

      window.ab_test.source = 'cart';

      if (!isProduct || !isAbTestProduct) {
        console.debug('[AB] Non-product page, no reload.');
        return;
      }

      if (group === renderedGroup) {
        console.debug('[AB] Product page: finalized group matches rendered group, no reload.');
        return;
      }

      var url = new URL(window.location.href);
      url.searchParams.set('ab_group', group);
      console.debug('[AB] Product page: reloading for finalized group', group);
      window.location.replace(url.toString());
    })
    .catch(function (err) {
      console.warn('[AB] Failed to persist A/B group:', err);
    });
})();
